import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
export const Root = styled(Box)(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}));